/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * grimoire/v1/api.proto
 * OpenAPI spec version: version not set
 */

/**
 * DayOfWeek represents days of the week for scheduling.
Values align with ISO 8601 (Monday = 1, Sunday = 7).

 - DAY_OF_WEEK_UNSPECIFIED: Unspecified day.
 - DAY_OF_WEEK_MONDAY: Monday.
 - DAY_OF_WEEK_TUESDAY: Tuesday.
 - DAY_OF_WEEK_WEDNESDAY: Wednesday.
 - DAY_OF_WEEK_THURSDAY: Thursday.
 - DAY_OF_WEEK_FRIDAY: Friday.
 - DAY_OF_WEEK_SATURDAY: Saturday.
 - DAY_OF_WEEK_SUNDAY: Sunday.
 */
export type V1DayOfWeek = (typeof V1DayOfWeek)[keyof typeof V1DayOfWeek];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1DayOfWeek = {
  DAY_OF_WEEK_UNSPECIFIED: 'DAY_OF_WEEK_UNSPECIFIED',
  DAY_OF_WEEK_MONDAY: 'DAY_OF_WEEK_MONDAY',
  DAY_OF_WEEK_TUESDAY: 'DAY_OF_WEEK_TUESDAY',
  DAY_OF_WEEK_WEDNESDAY: 'DAY_OF_WEEK_WEDNESDAY',
  DAY_OF_WEEK_THURSDAY: 'DAY_OF_WEEK_THURSDAY',
  DAY_OF_WEEK_FRIDAY: 'DAY_OF_WEEK_FRIDAY',
  DAY_OF_WEEK_SATURDAY: 'DAY_OF_WEEK_SATURDAY',
  DAY_OF_WEEK_SUNDAY: 'DAY_OF_WEEK_SUNDAY',
} as const;
